
/* eslint-disable no-console */

/**
 * @author Andrew Gower <amogower@gmail.com>
 */

import axios from 'axios';

import {
    requestComplete,
    requestFailure,
    requestStart
} from '../../modules/request';

import { CustomAjaxError } from '../../errors';
// import { initiateUploadProgress, updateUploadProgress } from '../../modules/meta/meta';

/**
 * HTTP Class
 * @constructor
 * @param {Object} config - The store config object
 */
export default class HTTP {
    constructor(store) {
        if (!store) {
            throw new Error('HTTP->constructor: store - ', store);
        }
        const { dispatch, getState } = store;
        const { config } = getState();
        this.headers = {
            Accept: config.acceptHeader,
            'Accept-Language': config.userLang,
            'X-Zip-Inflection': 'camel'
        };
        if (config.bearerToken) {
            this.headers.Authorization = `bearer ${config.bearerToken}`;
        }
        this.config = config;
        this.dispatch = dispatch;
    }

    /**
     * The API method for getting all of a resource
     * @returns {Array} Array of resource objects
     */
    getAll() {
        this.method = 'GET';
        this.url = this.type;
        return this.launchRequest();
    }

    /**
     * The wrapper method for axios
     * @returns {Object} response
     */
    async launchRequest() {
        this.requestStart();
        try {
            const axiosConfig = {
                headers: this.headers,
                method: this.method,
                url: `${this.config.apiUrl}${this.url}`,
                validateStatus: status => status < 300
            };
            if (this.overwriteUrl) {
                axiosConfig.url = this.overwriteUrl;
            }
            if (this.method !== 'DELETE') {
                if (this.includes) {
                    axiosConfig.params = {
                        include: this.includes.join(',')
                    };
                }
                if (this.body) {
                    axiosConfig.data = this.body;
                }
                if (this.params) {
                    axiosConfig.params = {
                        ...axiosConfig.params,
                        ...this.params
                    };
                }
            }
            const response = await axios(axiosConfig);
            if (response) {
                this.requestComplete();
                return this.handleResponse(response);
            }
            console.log('Expected response object but received:', response);
            this.requestFailure();
            return this.handleError({
                message: 'Expected response object but received:',
                response
            });
        } catch (error) {
            this.requestFailure(error);
            this.handleError(error);
        }
    }

    requestComplete() {
        this.dispatch(requestComplete(this.method, this.type.toUpperCase()));
    }

    requestFailure(error) {
        this.dispatch(requestFailure(this.method, this.type.toUpperCase(), error));
    }

    requestStart() {
        this.dispatch(requestStart(this.method, this.type.toUpperCase()));
    }

    /**
     * The error-handling method for the API
     * @param {Object} error - The error object
     * @throws {Object} CustomAjaxError
     * @return {void}
     */
    handleError(error) {
        if (!error) {
            throw new Error(`HTTP->handleError: error - ${error}`);
        }
        if (error.response) {
            let type;
            if (error.response.status < 400) {
                type = 'Client Error';
            } else if (error.response.status >= 400 && error.response.status < 500) {
                type = 'Client Error';
            } else if (error.response.status >= 500) {
                type = 'Server Error';
            }
            throw new CustomAjaxError({
                config: {
                    ...error.config
                },
                name: error.name,
                message: error.response.data.message,
                type,
                response: {
                    ...error.response
                }
            });
        }
        console.log(error);
        throw new CustomAjaxError({
            message: error.message,
            name: 'Some Error'
        });
    }

    /**
     * The response-handling method for the API
     * @param {Object} response - The response object
     * @return {Object} Updated response object
     */
    handleResponse(response) {
        if (!response) {
            throw new Error(`HTTP->handleResponse: response - ${response}`);
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/API/HTTP/HTTP.js